import { cn } from '@latitude/token-utils';
import type {
  ComponentProps,
  ComponentRef,
  PropsWithChildren,
  Ref,
} from 'react';

/**
 * Wrapper component for the trigger element.
 *
 * @component
 * @example
 * ```tsx
 * <TriggerWrapper className="my-wrapper">
 *   <button>Click me</button>
 * </TriggerWrapper>
 * ```
 */
export const TriggerWrapper = ({
  children,
  className,
  ref,
  ...props
}: PropsWithChildren<ComponentProps<'div'>> & {
  ref?: Ref<ComponentRef<'div'>>;
}) => (
  <div
    ref={ref}
    className={cn(['w-full', 'flex', 'items-center', 'flex-wrap'], className)}
    {...props}
  >
    {children}
  </div>
);

TriggerWrapper.displayName = 'TriggerWrapper';
